/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
import type { ConfigurationEntry } from './ConfigurationEntry';
import { ConfigurationEntryFromJSON, ConfigurationEntryFromJSONTyped, ConfigurationEntryToJSON, } from './ConfigurationEntry';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface ConfigurationData
 *
 */
// create custom validators for the regexes
typia.customValidators.insert("pattern_ConfigurationData_id")("string")(() => {
    const regex = new RegExp(/^[a-f0-9]{24}$/);
    return (value: string) => !!regex.exec(value);
});
export interface ConfigurationData {
    /**
     * MongoDB ObjectId
     * #type string
     * #memberof ConfigurationData
        
        
    * @pattern_ConfigurationData_id
         */
    id: string;
    /**
     *
     * #type string
     * #memberof ConfigurationData
        
        
         */
    name: string;
    /**
     *
     * #type Array<ConfigurationEntry>
     * #memberof ConfigurationData
        
        
         */
    configs: Array<ConfigurationEntry>;
    /**
     * unix timestamp in milliseconds
     * #type number
     * #memberof ConfigurationData
        
    * @minimum 0
            
         */
    createdAt: number;
    /**
     * unix timestamp in milliseconds
     * #type number
     * #memberof ConfigurationData
        
    * @minimum 0
            
         */
    lastModifiedAt: number;
}
/**
 * Check if a given object implements the ConfigurationData interface.
 */
export function instanceOfConfigurationData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "configs" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "lastModifiedAt" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
import { ConfigurationEntryValidator, ConfigurationEntryStringifyShape, ConfigurationEntryStringifyShapeProperties, } from './ConfigurationEntry';
export const ConfigurationDataTypiaAssertEquals = (input: any) => {
    return ((input: any): ConfigurationData => {
        const __is = (input: any, _exceptionable: boolean = true): input is ConfigurationData => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.id && $is_custom("pattern_ConfigurationData_id", "string", "", input.id) && "string" === typeof input.name && (Array.isArray(input.configs) && input.configs.every((elem: any, _index1: number) => "object" === typeof elem && null !== elem && $io1(elem, true && _exceptionable))) && ("number" === typeof input.createdAt && 0 <= input.createdAt) && ("number" === typeof input.lastModifiedAt && 0 <= input.lastModifiedAt) && (5 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["id", "name", "configs", "createdAt", "lastModifiedAt"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io1 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.name && 1 <= input.name.length && ("string" === typeof input.path && 1 <= input.path.length) && true && ("NUMERIC_INT" === input.valueDataType || "NUMERIC_FLOAT" === input.valueDataType || "CATEGORICAL_STRING" === input.valueDataType || "CATEGORICAL_INT" === input.valueDataType || "CATEGORICAL_BOOLEAN" === input.valueDataType || "CATEGORICAL_DATETIME" === input.valueDataType || "CATEGORICAL_TIMESTAMP" === input.valueDataType || "OTHER_STRING" === input.valueDataType) && (4 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["name", "path", "defaultValue", "valueDataType"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is ConfigurationData => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.id && ($is_custom("pattern_ConfigurationData_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_ConfigurationData_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string",
                    value: input.id
                })) && ("string" === typeof input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                })) && ((Array.isArray(input.configs) || $guard(_exceptionable, {
                    path: _path + ".configs",
                    expected: "Array<ConfigurationEntry>",
                    value: input.configs
                })) && input.configs.every((elem: any, _index1: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".configs[" + _index1 + "]",
                    expected: "ConfigurationEntry",
                    value: elem
                })) && $ao1(elem, _path + ".configs[" + _index1 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".configs[" + _index1 + "]",
                    expected: "ConfigurationEntry",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".configs",
                    expected: "Array<ConfigurationEntry>",
                    value: input.configs
                })) && ("number" === typeof input.createdAt && (0 <= input.createdAt || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number (@minimum 0)",
                    value: input.createdAt
                })) || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number",
                    value: input.createdAt
                })) && ("number" === typeof input.lastModifiedAt && (0 <= input.lastModifiedAt || $guard(_exceptionable, {
                    path: _path + ".lastModifiedAt",
                    expected: "number (@minimum 0)",
                    value: input.lastModifiedAt
                })) || $guard(_exceptionable, {
                    path: _path + ".lastModifiedAt",
                    expected: "number",
                    value: input.lastModifiedAt
                })) && (5 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["id", "name", "configs", "createdAt", "lastModifiedAt"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.name && (1 <= input.name.length || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@minLength 1)",
                    value: input.name
                })) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                })) && ("string" === typeof input.path && (1 <= input.path.length || $guard(_exceptionable, {
                    path: _path + ".path",
                    expected: "string (@minLength 1)",
                    value: input.path
                })) || $guard(_exceptionable, {
                    path: _path + ".path",
                    expected: "string",
                    value: input.path
                })) && true && ("NUMERIC_INT" === input.valueDataType || "NUMERIC_FLOAT" === input.valueDataType || "CATEGORICAL_STRING" === input.valueDataType || "CATEGORICAL_INT" === input.valueDataType || "CATEGORICAL_BOOLEAN" === input.valueDataType || "CATEGORICAL_DATETIME" === input.valueDataType || "CATEGORICAL_TIMESTAMP" === input.valueDataType || "OTHER_STRING" === input.valueDataType || $guard(_exceptionable, {
                    path: _path + ".valueDataType",
                    expected: "(\"CATEGORICAL_BOOLEAN\" | \"CATEGORICAL_DATETIME\" | \"CATEGORICAL_INT\" | \"CATEGORICAL_STRING\" | \"CATEGORICAL_TIMESTAMP\" | \"NUMERIC_FLOAT\" | \"NUMERIC_INT\" | \"OTHER_STRING\")",
                    value: input.valueDataType
                })) && (4 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["name", "path", "defaultValue", "valueDataType"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "ConfigurationData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "ConfigurationData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const ConfigurationDataTypiaAssertStringify = (input: ConfigurationData): string => {
    return ((input: any): string => { const assert = (input: any): ConfigurationData => {
        const __is = (input: any): input is ConfigurationData => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            const $io0 = (input: any): boolean => "string" === typeof input.id && $is_custom("pattern_ConfigurationData_id", "string", "", input.id) && "string" === typeof input.name && (Array.isArray(input.configs) && input.configs.every((elem: any) => "object" === typeof elem && null !== elem && $io1(elem))) && ("number" === typeof input.createdAt && !Number.isNaN(input.createdAt) && 0 <= input.createdAt) && ("number" === typeof input.lastModifiedAt && !Number.isNaN(input.lastModifiedAt) && 0 <= input.lastModifiedAt);
            const $io1 = (input: any): boolean => "string" === typeof input.name && 1 <= input.name.length && ("string" === typeof input.path && 1 <= input.path.length) && true && ("NUMERIC_INT" === input.valueDataType || "NUMERIC_FLOAT" === input.valueDataType || "CATEGORICAL_STRING" === input.valueDataType || "CATEGORICAL_INT" === input.valueDataType || "CATEGORICAL_BOOLEAN" === input.valueDataType || "CATEGORICAL_DATETIME" === input.valueDataType || "CATEGORICAL_TIMESTAMP" === input.valueDataType || "OTHER_STRING" === input.valueDataType);
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is ConfigurationData => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.id && ($is_custom("pattern_ConfigurationData_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_ConfigurationData_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string",
                    value: input.id
                })) && ("string" === typeof input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                })) && ((Array.isArray(input.configs) || $guard(_exceptionable, {
                    path: _path + ".configs",
                    expected: "Array<ConfigurationEntry>",
                    value: input.configs
                })) && input.configs.every((elem: any, _index1: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".configs[" + _index1 + "]",
                    expected: "ConfigurationEntry",
                    value: elem
                })) && $ao1(elem, _path + ".configs[" + _index1 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".configs[" + _index1 + "]",
                    expected: "ConfigurationEntry",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".configs",
                    expected: "Array<ConfigurationEntry>",
                    value: input.configs
                })) && ("number" === typeof input.createdAt && !Number.isNaN(input.createdAt) && (0 <= input.createdAt || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number (@minimum 0)",
                    value: input.createdAt
                })) || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number",
                    value: input.createdAt
                })) && ("number" === typeof input.lastModifiedAt && !Number.isNaN(input.lastModifiedAt) && (0 <= input.lastModifiedAt || $guard(_exceptionable, {
                    path: _path + ".lastModifiedAt",
                    expected: "number (@minimum 0)",
                    value: input.lastModifiedAt
                })) || $guard(_exceptionable, {
                    path: _path + ".lastModifiedAt",
                    expected: "number",
                    value: input.lastModifiedAt
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.name && (1 <= input.name.length || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@minLength 1)",
                    value: input.name
                })) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                })) && ("string" === typeof input.path && (1 <= input.path.length || $guard(_exceptionable, {
                    path: _path + ".path",
                    expected: "string (@minLength 1)",
                    value: input.path
                })) || $guard(_exceptionable, {
                    path: _path + ".path",
                    expected: "string",
                    value: input.path
                })) && true && ("NUMERIC_INT" === input.valueDataType || "NUMERIC_FLOAT" === input.valueDataType || "CATEGORICAL_STRING" === input.valueDataType || "CATEGORICAL_INT" === input.valueDataType || "CATEGORICAL_BOOLEAN" === input.valueDataType || "CATEGORICAL_DATETIME" === input.valueDataType || "CATEGORICAL_TIMESTAMP" === input.valueDataType || "OTHER_STRING" === input.valueDataType || $guard(_exceptionable, {
                    path: _path + ".valueDataType",
                    expected: "(\"CATEGORICAL_BOOLEAN\" | \"CATEGORICAL_DATETIME\" | \"CATEGORICAL_INT\" | \"CATEGORICAL_STRING\" | \"CATEGORICAL_TIMESTAMP\" | \"NUMERIC_FLOAT\" | \"NUMERIC_INT\" | \"OTHER_STRING\")",
                    value: input.valueDataType
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "ConfigurationData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "ConfigurationData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: ConfigurationData): string => {
        const $io1 = (input: any): boolean => "string" === typeof input.name && 1 <= input.name.length && ("string" === typeof input.path && 1 <= input.path.length) && true && ("NUMERIC_INT" === input.valueDataType || "NUMERIC_FLOAT" === input.valueDataType || "CATEGORICAL_STRING" === input.valueDataType || "CATEGORICAL_INT" === input.valueDataType || "CATEGORICAL_BOOLEAN" === input.valueDataType || "CATEGORICAL_DATETIME" === input.valueDataType || "CATEGORICAL_TIMESTAMP" === input.valueDataType || "OTHER_STRING" === input.valueDataType);
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        const $so0 = (input: any): any => `{"id":${$string(input.id)},"name":${$string(input.name)},"configs":${`[${input.configs.map((elem: any) => $so1(elem)).join(",")}]`},"createdAt":${input.createdAt},"lastModifiedAt":${input.lastModifiedAt}}`;
        const $so1 = (input: any): any => `{${undefined === input.defaultValue || "function" === typeof input.defaultValue ? "" : `"defaultValue":${undefined !== input.defaultValue ? JSON.stringify(input.defaultValue) : undefined},`}"name":${$string(input.name)},"path":${$string(input.path)},"valueDataType":${(() => {
            if ("string" === typeof input.valueDataType)
                return $string(input.valueDataType);
            if ("string" === typeof input.valueDataType)
                return "\"" + input.valueDataType + "\"";
            $throws({
                expected: "(\"CATEGORICAL_BOOLEAN\" | \"CATEGORICAL_DATETIME\" | \"CATEGORICAL_INT\" | \"CATEGORICAL_STRING\" | \"CATEGORICAL_TIMESTAMP\" | \"NUMERIC_FLOAT\" | \"NUMERIC_INT\" | \"OTHER_STRING\")",
                value: input.valueDataType
            });
        })()}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const ConfigurationDataValidatorShape = {
    'id': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'name': yup.string().defined(),
    'configs': yup.array().of(ConfigurationEntryValidator).defined(),
    'createdAt': yup.number().min(0).defined(),
    'lastModifiedAt': yup.number().min(0).defined(),
};
export const ConfigurationDataValidator = yup.object().shape(ConfigurationDataValidatorShape);
export const ConfigurationDataStringifyShapeProperties: ObjectSchema['properties'] = {
    'id': {
        'type': 'string',
        'pattern': "/^[a-f0-9]{24}$/".slice(1, -1),
    } as unknown as fastJSON.StringSchema,
    'name': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'configs': {
        type: 'array',
        items: {
            ConfigurationEntryStringifyShape
        }
    },
    'createdAt': {
        'type': 'number',
        'minimum': 0,
    } as unknown as fastJSON.NumberSchema,
    'lastModifiedAt': {
        'type': 'number',
        'minimum': 0,
    } as unknown as fastJSON.NumberSchema,
};
export const ConfigurationDataStringifyShape: ObjectSchema = {
    title: 'ConfigurationData Stringifier',
    type: 'object',
    properties: {
        ...ConfigurationDataStringifyShapeProperties
    },
    required: [
        'id',
        'name',
        'configs',
        'createdAt',
        'lastModifiedAt',
    ],
};
export const ConfigurationDataStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(ConfigurationDataStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const ConfigurationDataStringify: (data: ConfigurationData) => string = ConfigurationDataStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function ConfigurationDataFromJSON(json: any): ConfigurationData {
    return ConfigurationDataFromJSONTyped(json, false);
}
export function ConfigurationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'id': json['id'],
        'name': json['name'],
        'configs': ((json['configs'] as Array<any> || []).map(ConfigurationEntryFromJSON)),
        'createdAt': json['createdAt'],
        'lastModifiedAt': json['lastModifiedAt'],
    };
}
export function ConfigurationDataToJSON(value?: ConfigurationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'configs': ((value.configs as Array<any> || []).map(ConfigurationEntryToJSON)),
        'createdAt': value.createdAt,
        'lastModifiedAt': value.lastModifiedAt,
    };
}
